
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { Box, Link, Typography, Fade, Slide, IconButton } from "@mui/material";
// import { API_BASE_URL } from "../../config";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import CloseIcon from '@mui/icons-material/Close';
// import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
// import AnnouncementIcon from '@mui/icons-material/Announcement';

// export const Notification = () => {
//   const [notification, setNotification] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [visible, setVisible] = useState(false);
//   const [dismissed, setDismissed] = useState(false);

//   // Snackbar state
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   useEffect(() => {
//     const fetchNotification = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`${API_BASE_URL}/home-notification/social-news/`);
//         const data = response.data;

//         if (
//           data &&
//           typeof data === "object" &&
//           data.subject?.trim() &&
//           data.link?.trim()
//         ) {
//           setNotification(data);
//           // Show notification with smooth entrance
//           setTimeout(() => setVisible(true), 100);
//         } else {
//           setNotification(null);
//         }
//       } catch (error) {
//         console.error("Failed to fetch notification:", error);
//         setNotification(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchNotification();
//   }, []);

//   const handleDismiss = () => {
//     setVisible(false);
//     setTimeout(() => setDismissed(true), 300);
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return (
//       <Slide direction="down" in={!dismissed} timeout={500}>
//         <Box
//           sx={{
//             minHeight: "60px",
//             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             px: 2,
//             boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//             position: "relative",
//             overflow: "hidden",
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: '-100%',
//               width: '100%',
//               height: '100%',
//               background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
//               animation: 'shimmer 2s infinite',
//             }
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//             <LoadingSpinner size={20} color="white" />
//             <Typography 
//               variant="body2" 
//               sx={{ 
//                 color: 'white', 
//                 fontWeight: 500,
//                 animation: 'pulse 1.5s ease-in-out infinite'
//               }}
//             >
//               Loading notifications...
//             </Typography>
//           </Box>
//         </Box>
//       </Slide>
//     );
//   }

//   if (dismissed || !notification) {
//     return null;
//   }

//   return (
//     <>
//       <Slide direction="down" in={visible && !dismissed} timeout={500}>
//         <Box
//           sx={{
//             minHeight: "60px",
//             background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             px: 2,
//             position: "relative",
//             overflow: "hidden",
//             boxShadow: "0 4px 20px rgba(238, 90, 36, 0.3)",
//             cursor: notification ? "pointer" : "default",
//             transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//             '&:hover': {
//               transform: 'translateY(-2px)',
//               boxShadow: '0 6px 25px rgba(238, 90, 36, 0.4)',
//               background: "linear-gradient(135deg, #ff5252 0%, #e74c3c 100%)",
//             },
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               height: '3px',
//               background: 'linear-gradient(90deg, #ffd700, #ff6b6b, #ee5a24)',
//               animation: 'progress 5s linear infinite',
//             }
//           }}
//         >
//           {/* Animated background elements */}
//           <Box
//             sx={{
//               position: 'absolute',
//               top: -50,
//               right: -50,
//               width: 100,
//               height: 100,
//               borderRadius: '50%',
//               background: 'rgba(255,255,255,0.1)',
//               animation: 'float 6s ease-in-out infinite',
//             }}
//           />
//           <Box
//             sx={{
//               position: 'absolute',
//               bottom: -30,
//               left: '10%',
//               width: 60,
//               height: 60,
//               borderRadius: '50%',
//               background: 'rgba(255,255,255,0.05)',
//               animation: 'float 4s ease-in-out infinite 1s',
//             }}
//           />

//           {/* Close button */}
//           {/* <IconButton
//             onClick={handleDismiss}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: '50%',
//               transform: 'translateY(-50%)',
//               color: 'white',
//               background: 'rgba(255,255,255,0.2)',
//               transition: 'all 0.3s ease',
//               '&:hover': {
//                 background: 'rgba(255,255,255,0.3)',
//                 transform: 'translateY(-50%) scale(1.1)',
//               }
//             }}
//           >
//             <CloseIcon fontSize="small" />
//           </IconButton> */}

//           {/* Notification icon */}
//           <Fade in={visible} timeout={800}>
//             <NotificationsActiveIcon 
//               sx={{ 
//                 color: 'white', 
//                 mr: 1,
//                 animation: 'bellRing 2s ease-in-out infinite',
//                 fontSize: { xs: '1rem', sm: '1.2rem' }
//               }} 
//             />
//           </Fade>

//           {notification ? (
//             <Fade in={visible} timeout={800}>
//               <Link
//                 href={notification.link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 underline="none"
//                 sx={{
//                   color: 'white',
//                   textDecoration: 'none',
//                   fontWeight: 600,
//                   fontSize: {
//                     xs: "0.8rem",
//                     sm: "0.9rem",
//                     md: "1rem",
//                   },
//                   textAlign: 'center',
//                   px: 1,
//                   py: 0.5,
//                   borderRadius: 1,
//                   transition: 'all 0.3s ease',
//                   background: 'rgba(255,255,255,0.1)',
//                   backdropFilter: 'blur(10px)',
//                   '&:hover': {
//                     background: 'rgba(255,255,255,0.2)',
//                     transform: 'scale(1.02)',
//                     boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                   },
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   maxWidth: '80%',
//                 }}
//               >
//                 <AnnouncementIcon sx={{ fontSize: '1rem', opacity: 0.9 }} />
//                 <Box 
//                   component="span"
//                   sx={{
//                     animation: 'textGlow 2s ease-in-out infinite alternate',
//                   }}
//                 >
//                   {notification.subject}
//                 </Box>
//               </Link>
//             </Fade>
//           ) : (
//             <Fade in={visible} timeout={800}>
//               <Typography 
//                 variant="body2" 
//                 sx={{ 
//                   color: 'white',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 1,
//                   opacity: 0.8
//                 }}
//               >
//                 <CloseIcon fontSize="small" />
//                 No notifications available
//               </Typography>
//             </Fade>
//           )}
//         </Box>
//       </Slide>

//       {/* Global styles for animations */}
//       <style jsx global>{`
//         @keyframes progress {
//           0% { transform: translateX(-100%); }
//           100% { transform: translateX(100%); }
//         }
        
//         @keyframes float {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-10px) rotate(180deg); }
//         }
        
//         @keyframes bellRing {
//           0%, 100% { transform: rotate(0deg); }
//           10%, 30%, 50%, 70%, 90% { transform: rotate(-5deg); }
//           20%, 40%, 60%, 80% { transform: rotate(5deg); }
//         }
        
//         @keyframes textGlow {
//           0% { text-shadow: 0 0 5px rgba(255,255,255,0.5); }
//           100% { text-shadow: 0 0 15px rgba(255,255,255,0.8), 0 0 20px rgba(255,255,255,0.6); }
//         }
        
//         @keyframes shimmer {
//           0% { transform: translateX(-100%); }
//           100% { transform: translateX(400%); }
//         }
        
//         @keyframes pulse {
//           0%, 100% { opacity: 1; }
//           50% { opacity: 0.7; }
//         }
//       `}</style>

//       {/* Snackbar */}
//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </>
//   );
// };


import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { Box, Link, Typography, Fade, Slide, IconButton } from "@mui/material";
import { API_BASE_URL } from "../../config";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import CloseIcon from '@mui/icons-material/Close';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import AnnouncementIcon from '@mui/icons-material/Announcement';

export const Notification = () => {
  const { t, i18n } = useTranslation();
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  // Log current language
  useEffect(() => {
    console.log("Current language:", i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const fetchNotification = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}/home-notification/social-news/`,
          {
            params: { 
              language: i18n.language 
            }
          }
        );
        const data = response.data;

        if (
          data &&
          typeof data === "object" &&
          data.subject?.trim() &&
          data.link?.trim()
        ) {
          setNotification(data);
          // Show notification with smooth entrance
          setTimeout(() => setVisible(true), 100);
        } else {
          setNotification(null);
        }
      } catch (error) {
        console.error("Failed to fetch notification:", error);
        setNotification(null);
      } finally {
        setLoading(false);
      }
    };

    fetchNotification();
  }, [i18n.language]); // Refetch when language changes

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(() => setDismissed(true), 300);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return (
      <Slide direction="down" in={!dismissed} timeout={500}>
        <Box
          sx={{
            minHeight: "60px",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            position: "relative",
            overflow: "hidden",
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: '-100%',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
              animation: 'shimmer 2s infinite',
            }
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <LoadingSpinner size={20} color="white" />
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'white', 
                fontWeight: 500,
                animation: 'pulse 1.5s ease-in-out infinite'
              }}
            >
              {t('loadingNotifications') || 'Loading notifications...'}
            </Typography>
          </Box>
        </Box>
      </Slide>
    );
  }

  if (dismissed || !notification) {
    return null;
  }

  return (
    <>
      <Slide direction="down" in={visible && !dismissed} timeout={500}>
        <Box
          sx={{
            minHeight: "60px",
            background: "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(238, 90, 36, 0.3)",
            cursor: notification ? "pointer" : "default",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            '&:hover': {
              transform: 'translateY(-2px)',
              boxShadow: '0 6px 25px rgba(238, 90, 36, 0.4)',
              background: "linear-gradient(135deg, #ff5252 0%, #e74c3c 100%)",
            },
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '3px',
              background: 'linear-gradient(90deg, #ffd700, #ff6b6b, #ee5a24)',
              animation: 'progress 5s linear infinite',
            }
          }}
          onClick={() => window.open(notification.link, '_blank', 'noopener,noreferrer')}
        >
          {/* Animated background elements */}
          <Box
            sx={{
              position: 'absolute',
              top: -50,
              right: -50,
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.1)',
              animation: 'float 6s ease-in-out infinite',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: -30,
              left: '10%',
              width: 60,
              height: 60,
              borderRadius: '50%',
              background: 'rgba(255,255,255,0.05)',
              animation: 'float 4s ease-in-out infinite 1s',
            }}
          />

          {/* Notification icon */}
          <Fade in={visible} timeout={800}>
            <NotificationsActiveIcon 
              sx={{ 
                color: 'white', 
                mr: 1,
                animation: 'bellRing 2s ease-in-out infinite',
                fontSize: { xs: '1rem', sm: '1.2rem' }
              }} 
            />
          </Fade>

          <Fade in={visible} timeout={800}>
            <Box
              sx={{
                color: 'white',
                fontWeight: 600,
                fontSize: {
                  xs: "0.8rem",
                  sm: "0.9rem",
                  md: "1rem",
                },
                textAlign: 'center',
                px: 1,
                py: 0.5,
                borderRadius: 1,
                transition: 'all 0.3s ease',
                background: 'rgba(255,255,255,0.1)',
                backdropFilter: 'blur(10px)',
                '&:hover': {
                  background: 'rgba(255,255,255,0.2)',
                  transform: 'scale(1.02)',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                },
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                maxWidth: '80%',
              }}
            >
              <AnnouncementIcon sx={{ fontSize: '1rem', opacity: 0.9 }} />
              <Box 
                component="span"
                sx={{
                  animation: 'textGlow 2s ease-in-out infinite alternate',
                }}
              >
                {notification.subject}
              </Box>
            </Box>
          </Fade>
        </Box>
      </Slide>

      {/* Global styles for animations */}
      <style jsx global>{`
        @keyframes progress {
         0% { transform: translateX(-100%); }
         100% { transform: translateX(100%); }
        }
        
        @keyframes float {
         0%, 100% { transform: translateY(0px) rotate(0deg); }
         50% { transform: translateY(-10px) rotate(180deg); }
        }
        
        @keyframes bellRing {
         0%, 100% { transform: rotate(0deg); }
         10%, 30%, 50%, 70%, 90% { transform: rotate(-5deg); }
         20%, 40%, 60%, 80% { transform: rotate(5deg); }
        }
        
        @keyframes textGlow {
         0% { text-shadow: 0 0 5px rgba(255,255,255,0.5); }
         100% { text-shadow: 0 0 15px rgba(255,255,255,0.8), 0 0 20px rgba(255,255,255,0.6); }
        }
        
        @keyframes shimmer {
         0% { transform: translateX(-100%); }
         100% { transform: translateX(400%); }
        }
        
        @keyframes pulse {
         0%, 100% { opacity: 1; }
         50% { opacity: 0.7; }
        }
      `}</style>

      {/* Snackbar */}
      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};
